import React from 'react';

/**
 * A slide-over drawer anchored to the screen edge, used instead of a
 * centered Modal for record-detail views (e.g. ticket detail) where a
 * side panel keeps the underlying list visible and in context.
 */
export default function SidePanel({
  open,
  onClose,
  header,
  children,
  footer,
  width = 460,
  side = 'right',
}: {
  open: boolean;
  onClose: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: number;
  side?: 'left' | 'right';
}) {
  if (!open) return null;
  const edge = side === 'right' ? 'right-0' : 'left-0';
  const enterAnim = side === 'right' ? 'panel-slide-in-right' : 'panel-slide-in-left';

  return (
    <div className="fixed inset-0 z-[100]" onClick={onClose}>
      <div className="absolute inset-0 bg-black/40 panel-fade-in" />
      <div
        onClick={e => e.stopPropagation()}
        className={`absolute top-0 ${edge} h-full bg-white shadow-2xl flex flex-col ${enterAnim}`}
        style={{ width: '100%', maxWidth: width }}
      >
        {header}
        <div className="flex-1 overflow-y-auto">{children}</div>
        {footer}
      </div>
      <style>{`
        @keyframes panelSlideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }
        @keyframes panelSlideInLeft { from { transform: translateX(-100%); } to { transform: translateX(0); } }
        @keyframes panelFadeIn { from { opacity: 0; } to { opacity: 1; } }
        .panel-slide-in-right { animation: panelSlideInRight 0.22s ease-out; }
        .panel-slide-in-left { animation: panelSlideInLeft 0.22s ease-out; }
        .panel-fade-in { animation: panelFadeIn 0.22s ease-out; }
      `}</style>
    </div>
  );
}
